import type {ParsedTimeSlot} from './time-input.types';
import {DayNightSelector} from './time-input.types';

export const createTimeSlots = (): string[] => {
  const getTimeInDropdownFormat = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleTimeString('en-GB', options);
  };

  const timeSlotIncrementsMins = 15;
  const timeSlotDateTime = new Date();
  const startDate = timeSlotDateTime.getDate();
  timeSlotDateTime.setHours(0);
  timeSlotDateTime.setMinutes(0);
  timeSlotDateTime.setSeconds(0);
  timeSlotDateTime.setMilliseconds(0);

  const slots = [];

  while (timeSlotDateTime.getDate() === startDate) {
    slots.push(getTimeInDropdownFormat(timeSlotDateTime).toUpperCase());
    timeSlotDateTime.setMinutes(timeSlotDateTime.getMinutes() + timeSlotIncrementsMins);
  }
  return slots;
};

export const convert24To12Hr = (timeHourIn24: number): number => {
  if (timeHourIn24 > 12) {
    return timeHourIn24 - 12;
  }

  if (timeHourIn24 === 0) {
    return 12;
  }
  return timeHourIn24;
};

export const convert12HrTo24Hr = (dayNightSelector: DayNightSelector, timeHourIn12: number): number => {
  if (dayNightSelector === DayNightSelector.AM) {
    if (timeHourIn12 === 12) {
      return 0;
    }
    return timeHourIn12;
  }

  if (timeHourIn12 < 12) {
    return timeHourIn12 + 12;
  }
  return 12;
};

export const is24hrPM = (timeHourIn24: number): boolean => {
  return timeHourIn24 >= 12;
};

export const parseTimeSlot = (slot: string): ParsedTimeSlot => {
  const [hourPart, rest] = slot.split(':');
  const [minutePart, meridiem] = rest.split(' ');

  return {
    hour12: Number(hourPart),
    minute: Number(minutePart),
    dayNight: meridiem.toUpperCase() === DayNightSelector.PM.toString() ? DayNightSelector.PM : DayNightSelector.AM,
  };
};

export const isTimeSlotBefore = (slot: string, selectedDate: Date, minDateTime: Date): boolean => {
  const {hour12, minute, dayNight} = parseTimeSlot(slot);

  const candidate = new Date(selectedDate);
  candidate.setHours(convert12HrTo24Hr(dayNight, hour12), minute, 0, 0);

  return candidate.getTime() < minDateTime.getTime();
};
